module.exports = __webpack_public_path__ + "img/accSolidIcon.bec48001.svg";